import styled from 'styled-components';

export const SiteSideMenuContainer = styled.div.attrs({ id: 'site-side-menu' })`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const SiteSideMenuWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: ${(props) => (props.isDashboard ? '70px' : '60px')};
  top: 0px;
  z-index: 1;
  overflow-y: auto;
  background-color: ${(props) => (props.isFromInterview ? 'var(--btnDarkTxt)' : props.isDashboard ? props.theme.pageBg : 'var(--siteBgColor)')};
  @media (min-width: 481px) {
    max-width: ${(props) => (props.isDashboard ? '300px' : '340px')};
  }
  @media (min-width: 992px) {
    max-width: unset;
  }
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => (props.isFromInterview || props.darkTheme ? '#ffffff1a' : '#d2e3ff')};
  }
`;

export const SiteSideMenuOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  z-index: 0;
  background: #000000a1;
  @media (min-width: 992px) {
    background: unset;
  }
`;
